import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'

// firebase init goes here
const config = {
    /* TEST DATABASE */
    /*
    apiKey: "AIzaSyAApFwhzt5xmp8WwD7-ATALDFHMuLt5cBU",
    authDomain: "vinval.firebaseapp.com",
    databaseURL: "https://vinval.firebaseio.com",
    projectId: "vinval",
    storageBucket: "vinval.appspot.com",
    messagingSenderId: "941809954860",
    appId: "1:941809954860:web:472d5101a904fa7250e189",
    measurementId: "G-Q9PK6THCL4"
    */
   
    /* REAL DATABASE */
    
    apiKey: "AIzaSyAB6QLpV6qk8U8aql2saEoc9mvT4G8CMLc",
    authDomain: "vinval-b3e18.firebaseapp.com",
    databaseURL: "https://vinval-b3e18.firebaseio.com",
    projectId: "vinval-b3e18",
    storageBucket: "vinval-b3e18.appspot.com",
    messagingSenderId: "693362616277",
    appId: "1:693362616277:web:5e290593c9bae1adfebf5c",
    measurementId: "G-924M22CY8P"
    
  };
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const database = firebase.database()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
    
}
db.settings(settings)

// firebase collections
const winesCollection = db.collection('wines')
const blogsCollection = db.collection('blogs')
const categoriesCollection = db.collection('categories')
const monthsCollection = db.collection('months')
const countriesCollection = db.collection('countries')
const messagesCollection = db.collection('messages')
const ratingsCollection = db.collection('ratings')
const grapesCollection = db.collection('grapes')
const adsCollection = db.collection('ads')
export {
    db,
    database,
    auth,
    currentUser,
    winesCollection,
    blogsCollection,
    categoriesCollection,
    monthsCollection,
    countriesCollection,
    messagesCollection,
    ratingsCollection,
    grapesCollection,
    adsCollection,
}